// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { miniMyAccountStyles } from "@guestsupply/App/Components/MiniMyAccount/MiniMyAccount";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

miniMyAccountStyles.wrapper = {
    css: css``,
};
miniMyAccountStyles.mainTitle = {
    variant: "h5",
    forwardAs: "p",
    css: css`
        padding: 17px;
        padding-bottom: 0;
        margin-bottom: 12px;
    `,
};

miniMyAccountStyles.linksSectionWrapper = {
    css: css`
        background-color: ${color("common.ui2")};
        padding-top: 16px;
    `,
};

miniMyAccountStyles.linkItems = {
    wrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            padding: 0 16px 12px;
            column-gap: 16px;
            &:last-child {
                padding-bottom: 4px;
            }
        `,
    },
    link: {
        color: "common.ui4",
        typographyProps: {
            size: 12,
            weight: "bold",
            css: css`
                letter-spacing: 0;
                line-height: 13px;
                margin-bottom: 12px;
            `,
        },
    },
    linkWrapper: {
        css: css`
            flex-basis: calc(50% - 8px);
        `,
    },
};

miniMyAccountStyles.profileInfoWrapper = {
    css: css`
        padding: 16px;
        width: 100%;
        display: flex;
        flex-direction: column;
    `,
};

miniMyAccountStyles.customerNameLabel = {
    size: 12,
    weight: 500,
    css: css`
        line-height: 13px;
        letter-spacing: 0;
    `,
};

miniMyAccountStyles.customerNameValue = {
    size: 12,
    weight: 400,
    css: css`
        line-height: 13px;
        letter-spacing: 0;
    `,
};

miniMyAccountStyles.accountNumberLabel = {
    size: 12,
    weight: 500,
    css: css`
        line-height: 13px;
        letter-spacing: 0;
    `,
};

miniMyAccountStyles.accountNumberValue = {
    size: 12,
    weight: 400,
    css: css`
        line-height: 13px;
        letter-spacing: 0;
    `,
};

miniMyAccountStyles.actionsWrapper = {
    css: css`
        padding: 17px 16px 16px;
        display: flex;
        width: 100%;
        column-gap: 12px;
        border-top: 1px solid ${color("common.border")};
    `,
};

miniMyAccountStyles.changeCustomerButton = {
    variant: "tertiary",
    sizeVariant: "medium",
    mergeCss: true,
    css: css`
        flex: 1 1 0%;
    `,
    typographyProps: {
        css: css`
            line-height: 15px;
        `,
    },
};

miniMyAccountStyles.signOutButton = {
    sizeVariant: "medium",
    mergeCss: true,
    css: css`
        flex: 1 1 0%;
    `,
    typographyProps: {
        css: css`
            line-height: 15px;
        `,
    },
};

miniMyAccountStyles.subTitle = {
    size: 13,
    weight: "bold",
    css: css`
        line-height: 14px;
        width: 100%;
        padding-bottom: 8px;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 12px;
    `,
};
